"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
function SoftPhoneIcon(props) {
    return (react_1.default.createElement(SvgIcon_1.default, __assign({}, props),
        react_1.default.createElement("path", { fillRule: "nonzero", d: "M20.25,2 C21.2629167,2 22.0833333,2.895 22.0833333,4 L22.0833333,16 C22.0833333,17.105 21.2629167,18 20.25,18 L13.8333333,18 L13.8333333,20 L15.6666667,20 L15.6666667,22 L8.33333333,22 L8.33333333,20 L10.1666667,20 L10.1666667,18 L3.75,18 C2.73708333,18 1.91666667,17.105 1.91666667,16 L1.91666667,4 C1.91666667,2.895 2.73708333,2 3.75,2 L20.25,2 Z M20.25,16 L20.25,4 L3.75,4 L3.75,16 L20.25,16 Z" }),
        react_1.default.createElement("path", { fillRule: "nonzero", d: "M6.58125,10.15775 C7.22925,11.43125 8.271,12.473 9.54675,13.121 L10.53675,12.12875 C10.6605,12.005 10.83825,11.969 10.9935,12.0185 C11.4975,12.185 12.03975,12.275 12.6,12.275 C12.84975,12.275 13.05,12.47525 13.05,12.725 L13.05,14.3 C13.05,14.54975 12.84975,14.75 12.6,14.75 C8.3745,14.75 4.95,11.3255 4.95,7.1 C4.95,6.85025 5.1525,6.65 5.4,6.65 L6.975,6.65 C7.22475,6.65 7.425,6.85025 7.425,7.1 C7.425,7.66025 7.515,8.2025 7.6815,8.7065 C7.731,8.86175 7.695,9.0395 7.57125,9.16325 L6.58125,10.15775 Z" })));
}
exports.default = SoftPhoneIcon;
